import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';

export interface Menu {
  headTitle1?: string;
  level?: number;
  path?: string;
  title?: string;
  icon?: string;
  type?: string;
  active?: boolean;
  id?: number;
  bookmark?: boolean;
  children?: Menu[];
  horizontalList?: boolean;
  items?: Menu[]
}


@Injectable({
  providedIn: 'root'
})
export class NavmenuService {

  public isDisplay!: boolean;
  public language: boolean = false;
  public isShow: boolean = false;
  public closeSidebar: boolean = false;
  sidebarItemsUpdated$ = new Subject<void>();
  noAccessTriggered$ = new Subject<{ requestedUrl: string }>();

  constructor() { }

  // MENUITEMS: Menu[] = [
  //   {
  //     headTitle1: "General",
  //   },
  //   { level: 1, id:2,  path: '/dashboard',  title: "dashboard", icon: "support-tickets", active: false, type: "link" },
  // ]


  NAME_ICON: any =
    {
      "Dashboard": "stroke-dashboard-active",
      "Site Summary": "stroke-dashboard-active",
      "Recharge Summary": "stroke-coins",
      "Site Specific": "stroke-sitespecific",
      "Assets Specific": "stroke-assets",
      "Other": "stroke-othersItems",
      "Log Viewer": "stroke-logs",
      "UI": "",
      "Recharge": "",
      "Reports": "stroke-report",
      "Recharge Report": "",
      "Load Type Master": "",
      "Billing Report": "",
      "Assets Master": "",
      "Monthly Report": "",
      "Daily Report": "",
      "Debit/Credit Report": "",
      "Reading Calibration": "",
      "Alarm Reports": "",
      "Consumer Search": "stroke-consumer",
      "Assets": "stroke-assets",
      "Configuration": "stroke-config",
      "BulkAction": "stroke-bulk",
      "Logs": 'stroke-logs1',
      "Ticket": 'stroke-ticket',
      "Offline Recharge": 'stroke-offlinerecharge',
      "EV Summary": 'stroke-ev',
      "Alarm Summary": 'stroke-alarm-summary',
      "Group Action": 'stroke-graction',
      "Bulk Reports": 'stroke-b-reports',
      "Administrator": 'stroke-admin',
      "Coupon": 'stroke-coins',
    }

  // MENUITEMS: Menu[] = [
  //   {
  //     headTitle1: "",
  //   },
  //   {
  //     id: 1,
  //     level: 1,
  //     title: "Main Dashboard",
  //     icon: "dashboard-active",
  //     type: "sub",
  //     active: true,
  //     path:"/dashboard"
  //   },
  //   {
  //     id: 2,
  //     level: 1,
  //     title: "Reports",
  //     icon: "report",
  //     type: "sub",
  //     active: false,
  //     path:"/dashboard"
  //   },

  // ]
  public item = new BehaviorSubject<Menu[]>([]);
}
